import { contemberPlatformExpertWithIntentPrompt } from '../contemberPlatformExpertPrompt';
import { applicationTypesMap } from '../types';
export const applicationTypeGeneratePrompt = contemberPlatformExpertWithIntentPrompt.human(`

I need you to choose one of the following application types:
${Object.values(applicationTypesMap).join('\n')}

Pick the one which matches the application purpose the best.

Respond only in a single phrase with the chosen application type.
	`);
//# sourceMappingURL=applicationTypeGeneratePrompt.js.map